import { useIntl } from 'react-intl';

import {
    useExperimentVariation,
    useTrackEventAmplitude,
} from '../../../../core/Tracking/Amplitude/Amplitude';
import { IconStars } from '../../../../design-system/components/icons/Stars';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { useUrlGenerator } from '../../../../shared/hooks/useUrlGenerator';

import style from './WhereToGoButton.module.css';

export function WhereToGoButton() {
    const { generatePath } = useUrlGenerator();
    const { trackEvent } = useTrackEventAmplitude();
    const { formatMessage } = useIntl();
    const ABHomepageWhereToGoConversation = useExperimentVariation('fr-hp-wheretogo-conversation');

    const redirectPath =
        ABHomepageWhereToGoConversation?.value === 'variation'
            ? 'https://where-to-go.evaneos.fr'
            : generatePath('where_to_go');

    return (
        <Typography
            as="a"
            scale="primary-body-regular"
            className={style.whereToGoButton}
            href={redirectPath}
            onClick={() => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.wheretogoClicked({
                        ...defaultProperties,
                        block: 'cover',
                    });
                });
            }}
        >
            {formatMessage({ id: 'page.home.coverCta.ouPartir' })}
            <IconStars className={style.starsIcon} />
        </Typography>
    );
}
